import { useAuth } from '../../context/AuthContext';

/**
 * Renders children only when the current user holds `permission`, and, when
 * `survey` is given, their access to that survey allows it too.
 */
const Can = ({ permission, survey, children, fallback = null }) => {
  const { can } = useAuth();
  return can(permission, survey) ? children : fallback;
};

export default Can;
